import React from 'react';
import SidebarUnitDesktop from 'components/sidebar/components/SidebarUnitDesktop';
import { WalletIcon } from 'assets/icons';

const BillingDL = () => {
  return (
    <SidebarUnitDesktop
      routeName="Facturation"
      routeSidebar="/billing/invoices"
      activePatterns={['/billing']}
      icon={WalletIcon}
      text="Facturation"
    />
  );
};

export default BillingDL;
